module.exports = "pegasus/assets/theme3/medium/7.jpg";